import React from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../../i18n';

type LanguageTabsProps = {
  compact?: boolean;
};

const LanguageTabs: React.FC<LanguageTabsProps> = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('en') ? 'en' : 'es';

  const baseButtonStyle: React.CSSProperties = {
    border: '1px solid #d0d5dd',
    background: '#f8fafc',
    color: '#1f2937',
    padding: compact ? '4px 10px' : '6px 12px',
    fontSize: compact ? 12 : 13,
    cursor: 'pointer',
    lineHeight: 1,
  };

  const activeStyle: React.CSSProperties = {
    background: '#003270',
    color: '#ffffff',
    borderColor: '#003270',
  };

  return (
    <div style={{ display: 'inline-flex', borderRadius: 999, overflow: 'hidden' }}>
      <button
        type='button'
        onClick={() => setLanguage('es')}
        style={{
          ...baseButtonStyle,
          ...(current === 'es' ? activeStyle : null),
          borderRight: 'none',
          borderTopLeftRadius: 999,
          borderBottomLeftRadius: 999,
        }}
      >
        ES
      </button>
      <button
        type='button'
        onClick={() => setLanguage('en')}
        style={{
          ...baseButtonStyle,
          ...(current === 'en' ? activeStyle : null),
          borderTopRightRadius: 999,
          borderBottomRightRadius: 999,
        }}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageTabs;
